export default __webpack_public_path__ + "static/media/blueSlab.d00cc6af.svg";